/* src/app/components/notifications-card-item/notifications-card-item.component.scss */
.card-container {
  padding-top: 0.5rem;
}
.divider {
  border: 0.0625rem solid rgba(46, 46, 56, 0.08);
  padding: 0;
  margin: 0;
}
.icon {
  width: 2rem;
  height: 2rem;
}
.description-container {
  margin-top: 1rem;
}
.description-footer-container {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 300;
  font-family: EYInterstate;
  color: #72727f;
  margin: 0.5rem auto 0 4rem;
  padding-bottom: 1rem;
}
.description-footer-container .space {
  margin-right: 1rem;
}
.wrapper {
  position: relative;
  margin: 1rem 1rem 0.5rem;
  width: 2rem;
  height: 2rem;
}
.badge {
  display: block;
  position: absolute;
  height: 0.5rem;
  width: 0.5rem;
  top: 75%;
  left: 0;
  z-index: 99;
  border-radius: 100%;
  background-color: #ffe600;
}
.hover-bg {
  margin-top: 0.5rem;
  margin-bottom: 0.5625rem;
  cursor: pointer;
}
.hover-bg:hover,
.hover-bg:active {
  background-color: rgba(116, 116, 128, 0.08);
}
/*# sourceMappingURL=notifications-card-item.component.css.map */
